// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NZUI","colMin":"styles_colMin__2hE-y"};